<template>
  <AlertDialogCancel
    v-bind="props"
    :class="cn('mt-2 sm:mt-0', $attrs.class ?? '')"
  >
    <slot />
  </AlertDialogCancel>
</template>

<script setup>
import { AlertDialogCancel } from 'radix-vue';
import { cn } from '../../utils.js';

const props = defineProps();
</script>
